export const DEFAULT_DATE_FORMAT = "MM.DD.YYYY"
export const YYYY_MM_DD_FORMAT = "YYYY-MM-DD"
export const DD_MM_YYYY_FORMAT = "DD-MM-YYYY"
export const US_DATE_FORMAT = "MM/DD/YYYY"
export const LOCAL_TIME_FORMAT = "LT"
export const US_DATE_TIME_FORMAT = `${US_DATE_FORMAT} ${LOCAL_TIME_FORMAT}`
export const MMM_DD_YYYY = "MMM DD, YYYY"
export const BEAUTY_DATE_FORMAT = "MMMM DD, YYYY"
export const DAY_14_NUMBER = 14
